import { initializeApp } from "firebase/app";
import { getAuth, onIdTokenChanged } from "firebase/auth";

// Firebase web config. These values are not secrets — they're public client
// identifiers, safe to commit. Backend token verification (issuer/audience) is
// what actually enforces auth.
const firebaseConfig = {
  apiKey: "AIzaSyAkuw9DjgI8R7HS7fyti_k4mtAeDaIsQfE",
  authDomain: "trattoria-demi.firebaseapp.com",
  projectId: "trattoria-demi",
  storageBucket: "trattoria-demi.firebasestorage.app",
  messagingSenderId: "885380180018",
  appId: "1:885380180018:web:cdcbc3ab348bf08de5f42b",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// This is an in-house, fixed-account login (no public sign up). Firebase Auth
// keys accounts by email, so the staff "usernames" map onto emails under this
// domain. Users can type either the bare username (e.g. "owner") or the full
// email — both resolve to the same account.
const EMAIL_DOMAIN = "trattoriademi.com";

export function usernameToEmail(username) {
  const value = (username || "").trim();
  return value.includes("@") ? value : `${value}@${EMAIL_DOMAIN}`;
}

// Owner is the only privileged role; the "server" account does not get the
// dashboard navigation/admin views. With two fixed accounts we derive the role
// from the account's email rather than maintaining custom claims.
export function isOwner(user) {
  if (!user || !user.email) return false;
  return user.email.toLowerCase().startsWith(`owner@`);
}

// Cache the current ID token so the (synchronous) request-header builder in
// api.js can read it without going async. Firebase proactively refreshes the
// token in the background and fires this listener on every refresh, login, and
// logout, so the cached value stays current for the duration of a session.
let currentIdToken = null;
onIdTokenChanged(auth, async (user) => {
  currentIdToken = user ? await user.getIdToken() : null;
});

export function getCurrentIdToken() {
  return currentIdToken;
}
